import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { SIZES } from 'src/styles/theme'
import styled from 'styled-components'
import LoadIcon from '../components/LoadIcon'

const CustomModal = styled(Modal)`
  .modal-content {
    border-radius: 0px;
    border: none;
    background: transparent;
    padding: 0;
    color: #05093A;
  }
  .modal-header {
    border: none;
    padding: 0;
  }
  .close {
    font-size: 52px;
    opacity: 1;
    color: #00FFFF;
    padding: 0;
    text-shadow: none;
    &:not(:disabled):hover {
      color: #00FFFF;
      opacity: 1;
    }
  }
  .iframe-container {
    padding: 56.25% 0 0 0;
    position: relative;
    flex: 1;
    ${SIZES.mobile} {
      padding:177.78% 0 0 0;
    }
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  .modal-body {
    padding: 0;
  }
`

export default function PreviewModal({ entry, showModal, closeModal }) {
  const [loading, setLoading] = useState(true)
  
  return (
    <CustomModal
      show={showModal}
      onHide={closeModal}
      size="xl"
      aria-labelledby="message"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div className="iframe-container" >
          {loading && <LoadIcon />}
          <iframe
            width="100%"
            height="100%"
            title="TikTok Challenge"
            src={`https://player.vimeo.com/video/${entry.vimeo_link}?autoplay=1&byline=0&title=0`}
            allow="autoplay; fullscreen; encrypted-media"
            allowFullScreen
            allowtransparency="true"
            frameBorder="0"
            onLoad={() => {
              setLoading(false)
            }}
          />
        </div>
      </Modal.Body>
    </CustomModal>
  )
}
